







// http://192.168.3.17:91/api/v1/Customer/GetAllSimpleCustomers


import { baseApiUrl } from "../../../env";

import axiosInstance from "../../../Axios/axios";

// http://192.168.3.17:91/api/v1/Cheque/GetChequeCalenderView

const  GetAllSimpleCustomers=async({queryKey})=>{
    let body=queryKey[1]
    const GetAllSimpleCustomers_URL='Customer/GetAllSimpleCustomers';
    return await axiosInstance.post(GetAllSimpleCustomers_URL,body)
}

export {
    GetAllSimpleCustomers
}
